export default "__VITE_ASSET__Du559eia__"